import React, { useState } from 'react';
import classNames from 'classnames';

import { CloseMobile } from '@/icons/index';

import TextBlock from '../TextBlock/TextBlock';
import Video from '../Video/Video';
import PersonCard from '../../business-testimonials/PersonCard/PersonCard';
import SectionTitle from '../SectionTitle/SectionTitle';

import styles from './VideoBlock.module.scss';

const VideoBlock = ({ data }) => {
  const [videoId, setVideoId] = useState(false);
  const [videoPreview, setVideoPreview] = useState('');

  const renderItems = (item, key) => (
    <PersonCard
      data={item}
      showVideo={(id) => setVideoId(id)}
      key={key}
      setVideoPreview={setVideoPreview}
      itemScope
      itemType='http://schema.org/Person'
    />
  );

  return (
    <>
      <div
        className='wrapper'
        data-testid='video-element'
        itemScope
        itemType='http://schema.org/CreativeWork'
      >
        {data?.title && (
          <SectionTitle
            titleModify={classNames(styles['page-title'], 'title--large')}
          >
            {data.title}
          </SectionTitle>
        )}
        {data?.description && (
          <TextBlock className={classNames(styles['page-text'], 'text--large')}>
            {data.description}
          </TextBlock>
        )}
        {!!data?.items && (
          <div className={styles.peoplesList}>
            {data.items.map(renderItems)}
          </div>
        )}
      </div>
      {videoId && (
        <div className={styles.video}>
          <div className={styles.videoContent}>
            <div className={styles.close} onClick={() => setVideoId(false)}>
              <CloseMobile />
            </div>
            <Video
              className={styles.videoItem}
              video={{
                preview: videoPreview,
                videoId,
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default VideoBlock;
